import { Layout, TIconNameKey } from '@se-admin/falcon';
import * as React from 'react';
import SaleLabel, { ISaleLabelProps } from '../SaleLabel';

export interface IPromotion {
  color: string;
  title: string;
  description: string;
  icon: TIconNameKey;
}
export interface ISaleLabelListProps {
  saleLabelListProperties?: TSaleLabelRenderPropsArray;
  variant?: SaleLabelVariant;
}

interface ISaleLabelRenderProps extends ISaleLabelProps {
  show?: boolean;
  translationKey?: string;
  tooltipTranslationKey?: string;
  tooltipTitleTranslationKey?: string;
}
export type TSaleLabelPropsArray = ISaleLabelProps[];
export type TSaleLabelRenderPropsArray = ISaleLabelRenderProps[];

export enum SaleLabelVariant {
  normal = 'normal',
  map = 'map',
  small = 'small',
}

/**
 * A container to hold the sale labels. It takes props to determine which label to show.
 * There internal logic to determine which labels show with text and in which order.
 */
const SaleLabelList: React.FunctionComponent<ISaleLabelListProps> = ({
  saleLabelListProperties,
  variant,
}) => {
  return (
    <Layout.Container alignItems="center">
      {saleLabelListProperties.map(props => {
        const { backgroundColor, icon, saleLabelTranslations } = props;

        return (
          <SaleLabel
            key={`${saleLabelTranslations.translatedLabelValue}_${icon}`}
            backgroundColor={backgroundColor}
            icon={icon}
            saleLabelTranslations={saleLabelTranslations}
            saleLabelVariant={variant}
            dataAttributes={{ testid: `saleLabel` }}
          />
        );
      })}
    </Layout.Container>
  );
};

export default SaleLabelList;
